import { findSpecialist } from '@secretario/shared';
import { useParams } from 'wouter';
import {
  SpecialistVisualIcon,
  specialistVisualForKey,
} from '../components/equipe/SpecialistVisualIcon.js';
import { BomDiaView } from '../components/equipe/views/BomDiaView.js';
import { ClimaView } from '../components/equipe/views/ClimaView.js';
import { ComprasView } from '../components/equipe/views/ComprasView.js';
import { ContasView } from '../components/equipe/views/ContasView.js';
import { DatasView } from '../components/equipe/views/DatasView.js';
import { HoroscopoView } from '../components/equipe/views/HoroscopoView.js';
import { NoticiasView } from '../components/equipe/views/NoticiasView.js';
import { RadarPrecosView } from '../components/equipe/views/RadarPrecosView.js';
import { useSkillBack } from '../lib/skillBack.js';
import { PageShell } from '../components/stage/PageShell.js';
import './ported/habilidade.css';

// Especialistas com módulo próprio têm tela de verdade; os demais seguem nesta
// apresentação até o módulo deles entrar.
function ComingSoonView({ id }: { id: string }) {
  const back = useSkillBack();
  const skill = findSpecialist(id);
  if (!skill) {
    return (
      <PageShell kicker="Equipe" title="Não encontrei essa parte" onBack={back}>
        <p className="pgs-empty">Volte para a tela inicial e me peça de novo.</p>
      </PageShell>
    );
  }
  const learning = skill.lifecycle === 'coming_soon';
  const capabilities = skill.capabilities.slice(0, 3);
  const example = skill.ownerCommandExamples[0];
  return (
    <PageShell
      kicker={skill.name}
      title={learning ? 'Chega em breve' : skill.name}
      lead={skill.shortDescription}
      onBack={back}
    >
      <div className="pgs-note">
        <i>
          <SpecialistVisualIcon name={specialistVisualForKey(id)} size={18} />
        </i>
        <span>
          <b>O que muda no seu dia</b>
          <small>{skill.description}</small>
        </span>
      </div>
      {capabilities.length > 0 && (
        <section className="pgs-section">
          <h2 className="pgs-h2">Pensado para você</h2>
          {capabilities.map((capability) => (
            <div className="pgs-row" key={capability}>
              <span className="pgs-ic">
                <SpecialistVisualIcon name={specialistVisualForKey(id)} size={20} />
              </span>
              <span className="pgs-rowt">
                <b>{capability}</b>
              </span>
            </div>
          ))}
        </section>
      )}
      {example && (
        <div className="pgs-note">
          <i>“</i>
          <span>
            <b>Você vai poder pedir</b>
            <small>{example}</small>
          </span>
        </div>
      )}
    </PageShell>
  );
}

export function HabilidadePage() {
  const { id = '' } = useParams<{ id: string }>();
  // Cada habilidade desenha a própria página no molde do palco (PageShell),
  // com o selo do Secretário no topo e a volta para a Início.
  return (
    <div className="hab hab-page">
      {id === 'noticias' ? (
        <NoticiasView />
      ) : id === 'horoscopo' ? (
        <HoroscopoView />
      ) : id === 'clima' ? (
        <ClimaView />
      ) : id === 'contas' ? (
        <ContasView />
      ) : id === 'lista_compras' ? (
        <ComprasView />
      ) : id === 'datas_importantes' ? (
        <DatasView />
      ) : id === 'radar_precos' ? (
        <RadarPrecosView />
      ) : id === 'bom_dia' ? (
        <BomDiaView />
      ) : (
        <ComingSoonView id={id} />
      )}
    </div>
  );
}
